import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet';
import { LinkUp, LinkDown, LinkTop, LinkBottom } from "grommet-icons";

const RankArrows = (props) => {

    const { thisItem, rankUp, rankDown, rankTop, rankBottom, isFirst, isLast } = props

    const handleRankUp = () => {
        console.log('Moving up')
        rankUp(thisItem)
    }

    const handleRankDown = () => {
        console.log('Moving down')
        rankDown(thisItem)
    }

    const handleRankTop = () => {
        console.log('Moving to top')
        rankTop(thisItem)
    }

    const handleRankBottom = () => {
        console.log('Moving to bottom')
        rankBottom(thisItem)
    }

    return(
        <Box
          className="rank-arrows"
        >
            <div className="arrow" onClick={handleRankTop}> {
                isFirst ?
                    <span className="fas"></span>
                    :
                    <LinkTop className="fas"/>
            }
            </div>
            <div className="arrow" onClick={handleRankUp}> {
                isFirst || (rankUp == null) ?
                    <span className="fas"></span>
                    :
                    <LinkUp />
            }
            </div>
            <div className="arrow" onClick={handleRankDown}> {
                isFirst || (rankDown == null) ?
                    <span className="fas"></span>
                    :
                    <LinkDown />
            }
            </div>
            <div className="arrow" onClick={handleRankBottom}> {
                isLast ?
                    <span className="fas"></span>
                    :
                    <LinkBottom />
            }
            </div>
        </Box>
    )
}

export default RankArrows

RankArrows.propTypes = {}
